import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'

import styles from './widgets.module.sass'

const TransportEntry = ({ transport, providerEntities }) => {
	const { i18n, showDialog } = useGlobal()
	const isApproved = transport.state?.toLowerCase() === 'aprovada'

	return (
		<HStack
			className={styles['entry']}
			// columns={[2, 2]}
			flex={[
				[1, 1],
				[0, 0],
			]}
			gap='xsmall'
			justify='space-between'
			align='center'
			style={{ cursor: 'pointer' }}
			onClick={() =>
				showDialog(
					'TransportDetailDialog',
					i18n`Transport Requisition`,
					transport
				).catch(() => null)
			}
		>
			<div className={styles['entry-main']}>
				<h5>{transport.transportDateStr}</h5>
				<small>
					{transport.transportType} ·{' '}
					{providerEntities?.[transport.establishmentId]}
				</small>
			</div>
			<HStack gap='xsmall' align='center' justify='flex-end'>
				<span
					className={`${styles['transport-status']} ${
						isApproved ? styles['--approved'] : styles['--rejected']
					}`}
				>
					{isApproved ? i18n`Approved` : i18n`Rejected`}
				</span>
				<Icon name='next' width='16px' height='16px' />
			</HStack>
		</HStack>
	)
}

export default TransportEntry
